export default __webpack_public_path__ + "static/media/CRM-8.665ea93a.png";